import {
  Divider,
  FormControlLabel,
  Grid2,
  Switch,
  Typography,
} from "@mui/material";
import usePermission from "hooks/usePermission";
import { useFetchQuery, useMutation } from "hooks/useQueries";
import _ from "lodash";
import { useState } from "react";
import axiosInstance from "utils/axiosInstance";
import useDocumentTitle from "utils/useDocumentTitle";
import SimpleLoader from "./SimpleLoader";

interface PermissionGroup {
  permission: string;
  subHeading: string;
  isExist?: string[];
}

interface PermissionGroup {
  mainHeading: string;
  subPermission: PermissionGroup[];
}

interface Props {
  headerTitle: string;
  route: string;
  queryKey: string;
  permissionType: string;
}

interface APIResponseInterface {
  [key: string]: boolean;
}

const Permission = (props: Props) => {
  const { headerTitle, route, queryKey, permissionType } = props;

  useDocumentTitle(headerTitle);

  const [switchValues, setSwitchValues] = useState<any>({});

  const { permissions, permissionLoading } = usePermission({
    role: permissionType,
  });

  const { isFetching: isLoading } = useFetchQuery({
    key: [queryKey],
    route: route,
    success: (data: any) => setSwitchValues(data.data),
  });

  const { mutate: permissionChange } = useMutation({
    mutationKey: [queryKey],
    mutationFn: (data: APIResponseInterface) =>
      axiosInstance.patch(route, data),
  });

  if (isLoading || permissionLoading) return <SimpleLoader />;

  const handleChangePermission = (
    event: React.ChangeEvent<HTMLInputElement>,
    permission: string,
  ) => {
    const value = event.target.checked;
    setSwitchValues((prevData: any) => {
      return _.set({ ...prevData }, permission, value);
    });

    const permissionData = _.set({}, permission, value);

    permissionChange(permissionData);
  };

  const handleToggleAllPermissions = (
    event: React.ChangeEvent<HTMLInputElement>,
    dataItem: PermissionGroup,
  ) => {
    const isChecked = event.target.checked;
    const newSwitchValues = _.cloneDeep(switchValues);

    _.forEach(dataItem.subPermission, (subPermission) => {
      _.set(newSwitchValues, subPermission.permission, isChecked);
    });

    setSwitchValues(newSwitchValues);

    const permissionsData = _.reduce(
      dataItem.subPermission,
      (acc, subPermission) => {
        return _.set(acc, subPermission.permission, isChecked);
      },
      {},
    );

    permissionChange(permissionsData);
  };

  return (
    <Grid2 container spacing={3}>
      <Grid2 size={12}>
        {_.map(permissions, (dataItem, index) => {
          const allPermissionsEnabled = _.every(
            dataItem.subPermission,
            (subPermission) => _.get(switchValues, subPermission.permission),
          );

          return (
            <Grid2 container size={12} spacing={2}>
              <Grid2
                size={3}
                display={"flex"}
                alignItems={"flex-start"}
                key={index}
              >
                <FormControlLabel
                  control={
                    <Switch
                      checked={allPermissionsEnabled}
                      onChange={(e) => {
                        e.stopPropagation();
                        handleToggleAllPermissions(e, dataItem);
                      }}
                    />
                  }
                  label={
                    <Typography fontSize={16} fontWeight={600}>
                      {dataItem.mainHeading}
                    </Typography>
                  }
                />
              </Grid2>
              <Grid2
                container
                size={9}
                spacing={2}
                display={"inline-flex"}
                alignItems={"center"}
              >
                {_.map(dataItem.subPermission, (data, subIndex) => {
                  return (
                    <Grid2
                      size={6}
                      display={"flex"}
                      alignItems={"center"}
                      key={subIndex}
                    >
                      <FormControlLabel
                        control={
                          <Switch
                            sx={{ marginTop: "1px" }}
                            checked={
                              _.get(switchValues, data.permission) || false
                            }
                            name={data.permission}
                            onChange={(e) =>
                              handleChangePermission(e, data.permission)
                            }
                          />
                        }
                        label={
                          <div>
                            <Typography
                              fontSize={14}
                              fontWeight={500}
                              sx={{
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                // whiteSpace: "nowrap",
                                width: "100%",
                              }}
                            >
                              {data.heading}
                            </Typography>
                            {/* <Typography fontSize={12} color={"var(--neutral-500)"}>
                                      {"data.subText"}
                                    </Typography> */}
                          </div>
                        }
                        sx={{
                          alignItems: "center",
                          flexWrap: "nowrap",
                          width: "100%",
                        }}
                      />
                    </Grid2>
                  );
                })}
              </Grid2>
              <Grid2 size={12}>
                <Divider sx={{ mb: 2 }} />
              </Grid2>
            </Grid2>
          );
        })}
      </Grid2>
    </Grid2>
  );
};

export default Permission;
